import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, isRef as _isRef, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-382770af"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "q-mb-md" }
const _hoisted_2 = { class: "imgContainer" }
const _hoisted_3 = ["src"]

import {
  defineComponent, watch, ref, computed, Ref,
} from 'vue';
import { QFile } from 'quasar';
import imageCompression from 'browser-image-compression';
import to from 'await-to-js';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProfilePic',
  props: {
  modelValue: {
      type: String,
      default: 'avatar.png',
    },
},
  emits: ['update:modelValue'],
  setup(__props, { emit }) {

const props = __props;

/* eslint-disable no-console */




const urlProfile = ref('');
const img = ref<File>();
const rValue = computed({
  get: () => img.value,
  set: async (value) => {
    if (value) {
      console.log('Original image', value.size, value);
      const [errCompression, compressedImage] = await to(
        imageCompression(value, { maxWidthOrHeight: 300 }),
      );
      if (errCompression) {
        emit('update:modelValue', value);
        img.value = value;
      } else if (compressedImage) {
        // This convertion to File is needed because `imageCompression` returns a Blob
        // And it makes q-file component prop check to fail
        const compressedImageFile = new File([compressedImage], compressedImage.name);
        console.log('Compressed Image', compressedImage.size, compressedImageFile);
        emit('update:modelValue', compressedImageFile);
        img.value = compressedImageFile;
      }
    } else {
      img.value = value;
    }
  },
});
const qfile: Ref<QFile | null> = ref(null);
watch(rValue, () => {
  if (rValue.value == null) {
    urlProfile.value = '';
  } else {
    urlProfile.value = URL.createObjectURL(rValue.value);
  }
});

return (_ctx: any,_cache: any) => {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_avatar = _resolveComponent("q-avatar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_q_avatar, { class: "abs" }, {
        default: _withCtx(() => [
          _createVNode(_component_q_btn, {
            unelevated: "",
            round: "",
            color: "accent",
            input: "",
            class: "avatar-outline-semibold-white btnCont justify-center align-center",
            icon: qfile.value ?
            qfile.value.modelValue ? 'delete' : 'edit'
            : 'upload',
            onClick: _cache[1] || (_cache[1] = ($event: any) => (qfile.value ?
            qfile.value.modelValue ? rValue.value = undefined : qfile.value.pickFiles()
            : undefined))
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(QFile), {
                ref_key: "qfile",
                ref: qfile,
                modelValue: _unref(rValue),
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(rValue) ? (rValue).value = $event : null)),
                color: "transparent",
                name: "profile_picture",
                style: {"display":"none"},
                borderless: "",
                accept: "image/*",
                class: "abs"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["icon"])
        ]),
        _: 1
      }),
      _createVNode(_component_q_avatar, { class: "avatar" }, {
        default: _withCtx(() => [
          _createElementVNode("img", {
            src: !!urlProfile.value ? urlProfile.value : __props.modelValue,
            class: "avatar-outline-bold-primary img circle-avatar-img"
          }, null, 8, _hoisted_3)
        ]),
        _: 1
      })
    ])
  ]))
}
}

})